// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocation-container-UHcqu {
    margin: 0 auto;
    max-width: 1274px;
    padding: 0 24px;
}

.PopularLocation-displayGridTwo-m2pOW {
    display: grid;
    grid-template-columns: 192px 192px 192px 192px 192px 192px;
    grid-gap: 25px;
}

.PopularLocation-topBottomCss-nM9ww {
    padding: 60px 0 0;
}

.PopularLocation-containerTitle-CKpgQ {
    color: var(--common-text-color);
    margin: 0 0 35px;
    font-weight: bold;
    font-size: 36px;
    text-align: center;
}

@media screen and (max-width: 1170px) {
    .PopularLocation-containerTitle-CKpgQ {
        text-align: center;
    }
}

@media (max-width:767px) {
    .PopularLocation-displayGridTwo-m2pOW {
        grid-template-columns: 100%;
    }

    .PopularLocation-displayGridTwo-m2pOW div:nth-child(2),
    .PopularLocation-displayGridTwo-m2pOW div:nth-child(3),
    .PopularLocation-displayGridTwo-m2pOW div:nth-child(4),
    .PopularLocation-displayGridTwo-m2pOW div:nth-child(5),
    .PopularLocation-displayGridTwo-m2pOW div:nth-child(6) {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocation/PopularLocation.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,0DAA0D;IAC1D,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;;;;;QAKI,aAAa;IACjB;AACJ","sourcesContent":[".container {\n    margin: 0 auto;\n    max-width: 1274px;\n    padding: 0 24px;\n}\n\n.displayGridTwo {\n    display: grid;\n    grid-template-columns: 192px 192px 192px 192px 192px 192px;\n    grid-gap: 25px;\n}\n\n.topBottomCss {\n    padding: 60px 0 0;\n}\n\n.containerTitle {\n    color: var(--common-text-color);\n    margin: 0 0 35px;\n    font-weight: bold;\n    font-size: 36px;\n    text-align: center;\n}\n\n@media screen and (max-width: 1170px) {\n    .containerTitle {\n        text-align: center;\n    }\n}\n\n@media (max-width:767px) {\n    .displayGridTwo {\n        grid-template-columns: 100%;\n    }\n\n    .displayGridTwo div:nth-child(2),\n    .displayGridTwo div:nth-child(3),\n    .displayGridTwo div:nth-child(4),\n    .displayGridTwo div:nth-child(5),\n    .displayGridTwo div:nth-child(6) {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopularLocation-container-UHcqu`,
	"displayGridTwo": `PopularLocation-displayGridTwo-m2pOW`,
	"topBottomCss": `PopularLocation-topBottomCss-nM9ww`,
	"containerTitle": `PopularLocation-containerTitle-CKpgQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
